import LogoutResource from "./logout.resource";

const logoutModule = angular
  .module("app.resources.logout", [])
  .service("Logout", LogoutResource);

export default logoutModule;



// WEBPACK FOOTER //
// ./src/resources/logout/logout.module.js